// Mock data for Video Editor & Digital Marketing Expert Portfolio

export const heroContent = {
  headline: "Crafting Cinematic Visual Stories That Convert",
  subtext: "Video Editor & Digital Marketing Specialist blending storytelling, AI, and high-performance strategy.",
  ctaPrimary: "View My Work",
  ctaSecondary: "Let's Work Together"
};

export const aboutContent = {
  title: "About Me",
  bio: "I specialize in high-converting video content, cinematic edits, AI-powered content production, and digital marketing strategies that drive measurable growth.",
  stats: [
    { value: "50+", label: "Projects Delivered" },
    { value: "5M+", label: "Views Generated" },
    { value: "100%", label: "Client Satisfaction" }
  ]
};

export const portfolioCategories = [
  {
    id: 1,
    title: "Commercial Edits",
    description: "High-impact brand commercials and product showcases",
    thumbnail: "https://images.unsplash.com/photo-1574717024653-61fd2cf4d44d?w=600&q=80"
  },
  {
    id: 2,
    title: "Short Form Content",
    description: "Viral-ready content for TikTok, Reels & Shorts",
    thumbnail: "https://images.unsplash.com/photo-1598550476439-6847785fcea6?w=600&q=80"
  },
  {
    id: 3,
    title: "AI Generated Videos",
    description: "Cutting-edge AI-powered visual productions",
    thumbnail: "https://images.unsplash.com/photo-1677442136019-21780ecad995?w=600&q=80"
  },
  {
    id: 4,
    title: "Brand Storytelling",
    description: "Narrative-driven content that connects emotionally",
    thumbnail: "https://images.unsplash.com/photo-1492691527719-9d1e07e534b4?w=600&q=80"
  },
  {
    id: 5,
    title: "Performance Marketing",
    description: "Data-driven creatives optimized for conversions",
    thumbnail: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=600&q=80"
  }
];

export const softwareTools = [
  {
    id: 1,
    name: "Final Cut Pro",
    description: "Main editing software",
    logo: "https://i.imgur.com/8VdZXJj.png"
  },
  {
    id: 2,
    name: "DaVinci Resolve",
    description: "Color grading & complex animations",
    logo: "https://upload.wikimedia.org/wikipedia/commons/9/90/DaVinci_Resolve_17_logo.svg"
  },
  {
    id: 3,
    name: "CapCut",
    description: "Fast turnaround & short-form edits",
    logo: "https://i.imgur.com/qK9DJNJ.png"
  }
];

export const contactInfo = {
  headline: "Let's Build Something Exceptional.",
  email: "tanvir@tatmedia.xyz",
  instagram: "@tanvir.ahmed.topu",
  github: "@tanvirahmedtopu"
};

export const navLinks = [
  { label: "Work", href: "#portfolio" },
  { label: "Brands", href: "#social-media" },
  { label: "Tools", href: "#tools" },
  { label: "AI Tech", href: "#ai" },
  { label: "Contact", href: "#contact" }
];
